export const environment = {
  production: true,
  socket_host: 'https://app1.pepipost.com:3000',
  api_url: window.location.href.includes('netcoresmartech.com') ? 'https://prpodwhatsapp.netcoresmartech.com/index.php/' : 'https://preprod-email.netcorecloud.com/index.php/',
  whatspp_api_url: window.location.href.includes('netcoresmartech.com') ? 'https://preprod-original-gcp.netcoresmartech.com/index.php/' : 'https://preprod-original-gcp.netcorecloud.com/index.php/',
  sms_api_url: 'https://smsreporting-preprod.netcorecloud.com/index.php/',
  basePath: '/app/',
  // stripe_key: 'pk_live_QnH7t5fTBGb0Bd9uXhiu5miG', old key
  stripe_key: 'wMWMzcSb79PpgwojeVG',
  cdn_present: false,
  cdn_url: 'https://emailcdn.netcorecloud.com/abuild/11.4/',   // stage
  host:'https://cpaas.netcorecloud.com/',
  timeZone:'',
  region: ''
};


// export const environment = {
//   production: true,
//   socket_host: 'https://app1.pepipost.com:3000',
//   api_url: window.location.href.includes('netcoresmartech.com') ? 'https://prpodwhatsapp.netcoresmartech.com/index.php/' : 'https://preprod-email.netcorecloud.com/index.php/',
//   whatspp_api_url: window.location.href.includes('netcoresmartech.com') ? 'https://preprod-original-gcp.netcoresmartech.com/index.php/' : 'https://preprod-original-gcp.pepipost.com/index.php/',
//   sms_api_url: 'https://smsreporting.netcorecloud.com/index.php/',
//   basePath: '/app/',
//   // stripe_key: 'pk_live_QnH7t5fTBGb0Bd9uXhiu5miG', old key
//   stripe_key: 'wMWMzcSb79PpgwojeVG',
//   cdn_present: false,
//   cdn_url: 'https://emailcdn.netcorecloud.com/abuild/11.4/',   // stage
//   host:'https://cpaas.netcorecloud.com/',
//   timeZone:'',
//   region: ''
// };